import { ofType } from 'redux-observable';
import { switchMap, map, catchError } from 'rxjs/operators';
import { from, of } from 'rxjs';
import { FETCH_STAFF_MEMBER_NAMES_REQUEST, EPIC_ERROR } from 'Constants/redux';
import service from 'Api/service';
import { receiveStaffMemberNames } from 'Actions';

const FetchStaffMemberNamesEpic = (action$) =>
  action$.pipe(
    ofType(FETCH_STAFF_MEMBER_NAMES_REQUEST),
    switchMap(({ query }) =>
      from(
        service.get(
          `${import.meta.env.VITE_API_DOMAIN}/api/staff_members/names`,
          { per: 25, query }
        )
      ).pipe(
        map((response) => receiveStaffMemberNames(response)),
        catchError((error) => {
          console.error('FetchStaffMemberNamesEpic error', error);
          return of({ type: EPIC_ERROR });
        })
      )
    )
  );

export default FetchStaffMemberNamesEpic;
